import styles from './CategoryTitle.module.scss'

interface CategoryTitleProps {
  title: string
  count: number
}

export const CategoryTitle = ({ title, count }: CategoryTitleProps) => {
  return (
    <p className={styles.containerTitle}>
      {title} <span>{count}</span>
    </p>
  )
}
